module.exports = __webpack_public_path__ + "static/media/18a-01-HOME_ST-2018-199x133cm-oleo-sobre-tela.b21aea75.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/18a/18a-01-HOME_ST-2018-199x133cm-oleo-sobre-tela.jpg
// module id = 219
// module chunks = 0